<template>
  <div class="nc-appbar" style="z-index: 9999;">
    <div class="nc-appbar-tabs">
      <div class="ever" v-if="isLogin">
        <div class="cart">
          <div class="num cart-num" style="top: 5px; left: -8px;">{{cartNums}}</div>
          <a href="javascript:;" @click="toCart()">
            <span class="icon"></span> <span class="name"></span>
            <i class="new_msg" style="display:none;"></i>
          </a>
        </div>
        <div class="myfavorite">
          <router-link to="/member/favorite?status=1">
            <span class="icon"></span>
            <span class="tit">我的收藏</span>
          </router-link>
        </div>
        <!--<div class="chat">-->
        <!--<router-link to="/member/member">-->
        <!--<span class="icon"></span>-->
        <!--<span class="tit">在线联系</span>-->
        <!--</router-link>-->
        <!--</div>-->
        <div class="balance">
          <a @click="onlinePay(0)">
            <span class="icon"></span>
            <span class="tit">我的账户</span>
          </a>
        </div>
        <!-- <div class="recharge">
          <a @click="onlinePay(1)">
            <span class="icon"></span>
            <span class="tit">在线充值</span>
          </a>
        </div> -->
        <!--<div class="i-recharge"  v-if="isFirst">
          <a @click="onlinePay(2)">
            <span class="icon"></span>
            <span class="tit">积分充值</span>
          </a>
        </div>-->
      </div>
      <div class="variation">
        <div class="middle">
          <div class="user" v-if="isLogin">
            <!-- 已登录显示用户头像  -->
            <router-link to="/member/member">
              <div class="avatar">
                <img :src="$store.getters.face" height="120" width="120">
              </div>
            </router-link>
          </div>
          <div class="user" v-else>
            <!-- 已登录显示用户头像  -->
            <router-link to="login">
              <div class="avatar">
                <img src="//static.kxymall.com/images/default_face.jpg" height="120" width="120">
                <span class="tit">会员登录</span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="gotop" @click="goTop"><a><span class="icon"></span><span class="tit">返回顶部</span></a></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'sid', 'name', 'cartNums', 'isFirstBuy'
    ]),
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
    isFirst() {
      return this.isFirstBuy && this.isFirstBuy == 1 ? true : false;
    }
  },
  methods: {
    goTop() {
      scrollTo(0, 0);
    },
    onlinePay(type) {
      if (type === 0) {
        this.$router.push({
          path: '/account-center'
        })
      } else if (type === 1) {
        this.$router.push({
          path: '/showAlipay'
        });
      } else if (type === 2) {
        // 跳转到首购积分充值
        let tempwindow = window.open("about:blank", "_blank");
        tempwindow.location = resp.data.firstBuyDeposite;
      } else {
        this.$Message.warning(res.resDesc);
        let tempwindow = window.open("about:blank", "_blank");
        tempwindow.close();
      }
    },
    //购物车切换账号缓存问题
    toCart() {
      location.href = "/shopping-cart";
    }
  }
}
</script>

<style>
.nc-appbar {
  position: fixed;
  width: 35px;
  height: 100%;
  z-index: 9999;
  right: 0;
  top: 0;
  bottom: 0;
}

.nc-appbar-tabs {
  width: 35px;
  height: 100%;
}

.nc-appbar-tabs .ever {
  width: 35px;
  height: 158px;
  background-color: #000;
  position: absolute;
  z-index: 2;
  top: 50%;
  margin-top: -79px;
}

.nc-appbar-tabs .variation {
  width: 35px;
  height: 100%;
  background-color: #212121;
  position: relative;
  z-index: 1;
}

.nc-appbar-tabs .variation .middle {
  width: 35px;
  height: 250px;
  margin-top: -125px;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0;
}

.nc-hidebar {
  display: block;
  position: absolute;
  z-index: 3;
  bottom: 15px;
  right: -79px;
  cursor: pointer;
}

.nc-hidebar .nc-hidebar-bg {
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat -100px
    0;
  width: 79px;
  height: 56px;
  position: relative;
  z-index: 1;
}

.nc-hidebar .nc-hidebar-bg .user-avatar,
.nc-hidebar .nc-hidebar-bg .frame,
.nc-hidebar .nc-hidebar-bg .show {
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat;
  width: 36px;
  height: 36px;
  position: absolute;
  top: 10px;
  left: 15px;
}

.nc-hidebar .nc-hidebar-bg .user-avatar {
  background-position: -100px 0px;
  z-index: 1;
}

.nc-hidebar .nc-hidebar-bg .user-avatar img {
  max-width: 36px;
  max-height: 36px;
}

.nc-hidebar .nc-hidebar-bg .frame {
  background-position: -100px -70px;
  z-index: 2;
}

.nc-hidebar .nc-hidebar-bg .show {
  display: none;
  background-position: -140px -70px;
  z-index: 3;
}

.nc-hidebar .nc-hidebar-bg:hover .show {
  display: block;
}

.nc-hidebar:hover {
  background-position: -100px -60px;
}

.nc-appbar-tabs .user {
  display: block;
}

.nc-appbar-tabs .user .avatar {
  background-color: #fff;
  width: 28px;
  height: 28px;
  margin: 3px auto 4px auto;
  border-radius: 14px;
}

.nc-appbar-tabs .user .avatar img {
  width: 28px;
  height: 28px;
  border-radius: 14px;
}

.nc-appbar-tabs span.icon {
  display: block;
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat;
  width: 35px;
  height: 35px;
}

.nc-appbar-tabs .chat {
  display: block;
}

.nc-appbar-tabs .chat .icon {
  background-position: 0 0;
}

.nc-appbar-tabs .myfavorite .icon {
  background: url(//static.kxymall.com/images/favorite.png) no-repeat;
}

.nc-appbar-tabs .balance .icon {
  background: url(//static.kxymall.com/images/balance.png) no-repeat;
}

.nc-appbar-tabs .recharge .icon {
  background: url(//static.kxymall.com/images/recharge.png) no-repeat;
}

.nc-appbar-tabs .i-recharge .icon {
  background: url(//images.kxymall.com/i-recharge.png) no-repeat;
}

.nc-appbar-tabs .cart a {
  display: block;
  width: 35px;
  padding: 10px 0;
  border-top: dotted 1px #555;
  border-bottom: dotted 1px #555;
  position: relative;
  z-index: 1;
}

.nc-appbar-tabs .chat a,
.nc-appbar-tabs .user a,
.nc-appbar-tabs .compare a,
.nc-appbar-tabs .gotop a {
  display: block;
  width: 35px;
  height: 35px;
  padding: 5px 0 6px 0;
  position: relative;
  z-index: 1;
}

.nc-appbar-tabs .cart a:hover,
.nc-appbar-tabs .user a:hover,
.nc-appbar-tabs .chat a:hover,
.nc-appbar-tabs .compare a:hover,
.nc-appbar-tabs .gotop a:hover {
  text-decoration: none;
  background-color: #f32613;
}

.nc-appbar-tabs .compare .icon {
  background-position: 0 -40px;
}

.nc-appbar-tabs .cart .icon {
  background-position: 0 -120px;
}

.nc-appbar-tabs .cart .name {
  line-height: 16px;
  color: #fff;
  display: block;
  text-align: center;
  width: 15px;
  padding: 0 10px;
  white-space: pre-wrap;
}

.nc-appbar-tabs .prech {
  display: block;
  width: 35px;
  height: 158px;
}

.nc-appbar-tabs .gotop {
  position: fixed;
  bottom: 0;
}

.nc-appbar-tabs .gotop .icon {
  background-position: 0 -80px;
  opacity: 1;
}

.nc-appbar-tabs .gotop:hover .icon {
  opacity: 1;
}

.nc-appbar-tabs a i {
  font: 10px/12px Arial;
  color: #fff;
  background-color: #f32613;
  text-align: center;
  min-width: 12px;
  height: 12px;
  padding: 1px;
  border-radius: 100%;
  position: absolute;
  z-index: 1;
  top: 5px;
  right: 3px;
}

.nc-appbar-tabs a:hover i {
  color: #f32613;
  background-color: #fff;
}

.nc-appbar-tabs a span.tit {
  line-height: 25px;
  color: #fff;
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat -50px
    0;
  white-space: nowrap;
  width: 50px;
  height: 25px;
  display: none;
  padding: 4px 21px 4px 15px;
  position: absolute;
  z-index: 1;
  top: 5px;
  right: 29px;
}

.nc-appbar-tabs a:hover span.tit {
  display: block;
}

.nc-appbar-tabs .myfavorite a:hover span.tit {
  top: 60px;
}

/*.nc-appbar-tabs .balance a:hover span.tit { top:140px}*/
/*.nc-appbar-tabs .recharge a:hover span.tit { top:172px}*/
.nc-appbar-tabs .balance a:hover span.tit {
  top: 94px;
}

.nc-appbar-tabs .recharge a:hover span.tit {
  top: 128px;
}
.nc-appbar-tabs .i-recharge a:hover span.tit {
  top: 158px;
}
.nc-appbar-tabs .user-login-box {
  background-color: #fff;
  width: 240px;
  padding: 10px 40px 30px 40px;
  border: solid 1px #ccc;
  position: absolute;
  z-index: 2;
  top: 40%;
  margin-top: -120px;
  right: 50px;
  box-shadow: -4px 0 4px rgba(0, 0, 0, 0.25);
}

.nc-appbar-tabs .user-login-box i.arrow {
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat -100px -150px;
  width: 7px;
  height: 13px;
  position: absolute;
  z-index: 3;
  top: 45px;
  right: -7px;
}

.nc-appbar-tabs .user-login-box a.close {
  font: 600 11px /16px Verdana, Geneva, sans-serif;
  text-decoration: none;
  color: #999;
  text-align: center;
  width: 16px;
  height: 16px;
  position: absolute;
  z-index: 3;
  top: 10px;
  right: 10px;
}

.nc-appbar-tabs .user-login-box a {
  font: 12px/20px arial, "å®‹ä½“";
  color: #005ea6;
  text-decoration: underline;
  float: right;
}

.nc-appbar-tabs .user-login-box dl {
}

.nc-appbar-tabs .user-login-box dt {
  font: 13px/20px Arial, "microsoft yahei";
  height: 20px;
  padding: 10px 0 0;
}

.nc-appbar-tabs .user-login-box dt a {
  font: 12px/20px arial, "å®‹ä½“";
  color: #005ea6;
  text-decoration: underline;
  float: right;
}

.nc-appbar-tabs .user-login-box dd {
}

.nc-appbar-tabs .user-login-box dd .text {
  line-height: 20px;
  width: 226px;
  height: 20px;
  padding: 3px 5px;
  border: solid 1px #ccc;
}

.nc-appbar-tabs .user-login-box .bottom {
  margin-top: 20px;
}

.nc-appbar-tabs .user-login-box .submit {
  font: 600 14px/20px Arial, "microsoft yahei";
  color: #fff;
  background-color: #d93600;
  width: 240px;
  height: 30px;
  border: solid 1px #b22d00;
  cursor: pointer;
}

/*å·¥å…·æ¡-ä¼šå‘˜ä¿¡æ¯*/
.nc-appbar-tabs .user-info {
  background-color: #fff;
  width: 240px;
  padding: 9px 19px;
  border: solid 1px #ccc;
  position: absolute;
  z-index: 2;
  top: 40%;
  margin-top: -120px;
  right: 50px;
  box-shadow: -4px 0 4px rgba(0, 0, 0, 0.25);
}

.nc-appbar-tabs .user-info i.arrow {
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat -100px -150px;
  width: 7px;
  height: 13px;
  position: absolute;
  z-index: 3;
  top: 45px;
  right: -7px;
}

.nc-appbar-tabs .user-info .avatar {
  width: 88px;
  height: 88px;
  float: left;
  position: relative;
  z-index: 1;
}

.nc-appbar-tabs .user-info .avatar .frame {
  background: url(/point_bg.png) no-repeat 0 0;
  width: 88px;
  height: 88px;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
}

.nc-appbar-tabs .user-info .avatar img {
  width: 80px;
  height: 80px;
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 4px;
}

.nc-appbar-tabs .user-info dl {
  display: block;
  width: 140px;
  float: left;
  margin: 10px 0 0 10px;
}

.nc-appbar-tabs .user-info dt {
  font: 600 14px/20px "microsoft yahei";
  margin-bottom: 6px;
}

.nc-appbar-tabs .user-info dd {
  line-height: 22px;
}

#ncToolbar .content-box {
  background-color: #f5f5f5;
  width: 200px;
  height: 100%;
  border-left: solid 1px #7c8994;
  position: absolute;
  z-index: 0;
  top: 0;
  right: -210px;
  bottom: 0;
  box-shadow: -4px 0 2px rgba(0, 0, 0, 0.25);
}

#ncToolbar .content-box .top {
  height: 24px;
  padding: 9px 7px;
  border-bottom: dotted 1px #ccc;
  margin-bottom: 10px;
}

#ncToolbar .content-box .top h3 {
  font: 16px/24px "microsoft yahei";
  color: #333;
  display: inline-block;
}

#ncToolbar .content-box .top a.close {
  background: url(//static.kxymall.com/images/toolbar.png) no-repeat -100px -120px;
  width: 16px;
  height: 16px;
  margin-top: 4px;
  float: right;
}

#ncToolbar .content-box .goods-list {
  background-color: #fff;
  width: 180px;
  padding: 10px 0;
  margin: 0 auto;
}

#ncToolbar .content-box .goods-list li {
  width: 160px;
  padding: 0 0 10px 0;
  margin: 0 auto;
}

#ncToolbar .content-box .goods-info {
  width: auto;
  margin: auto;
}

.nc-appbar .goods-pic {
  width: 120px;
  height: 120px;
  margin: 0 auto 10px auto;
}

.nc-appbar .goods-pic a {
  line-height: 0;
  background: none;
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  *display: block;
  width: 120px;
  height: 120px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.nc-appbar .goods-pic a img {
  max-width: 120px;
  max-height: 120px;
  margin-top: expression(120-this.height/2);
  *margin-top: expression(60-this.height/2) /*IE6,7*/;
}

.nc-appbar .goods-name a {
  font-weight: normal;
  line-height: 16px;
  color: #555;
  background: none;
  text-align: left;
  display: block;
  width: 100%;
  height: 16px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nc-appbar .goods-price {
  font: 600 14px/20px Arial;
  color: #c00;
}

.nc-appbar .goods-price .del {
  font: normal 12px/20px Arial;
  color: #005ea6;
  display: none;
  float: right;
  cursor: pointer;
}

#ncToolbar .goods-list li:hover .goods-price .del {
  display: block;
}

#ncToolbar .content-box .no-compare {
  color: #999;
  line-height: 180px;
  text-align: center;
}

.nc-appbar .content-box .btn-box {
  background-color: #f5f5f5;
  text-align: center;
  width: 160px;
  padding: 10px;
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 10px;
}

.nc-appbar .content-box .btn-box a {
  background-color: #e74649;
  color: #ffffff;
  cursor: pointer;
  padding: 5px 10px;
}

.nc-appbar .content-box .btn-box .total-price {
  color: #777;
  padding-bottom: 10px;
}

.nc-appbar .cart-list {
  width: 180px;
  margin: 0 auto;
}

.nc-appbar .cart-list li {
  font-size: 0;
  *word-spacing: -1px /*IE6ã€7*/;
  background-color: #fff;
  padding: 4px;
  border: solid 1px #fff;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.nc-appbar .cart-list li:hover {
  border-color: #e74649;
  box-shadow: 3px 3px 0 rgba(204, 204, 204, 0.75);
}

.nc-appbar .cart-list .goods-pic,
.nc-appbar .cart-list dl {
  font-size: 12px;
  vertical-align: top;
  letter-spacing: normal;
  display: inline-block;
  *display: inline /*IE6ã€7*/;
  *zoom: 1;
}

.nc-appbar .cart-list .goods-pic {
  width: 40px;
  height: 40px;
  margin: 0;
}

.nc-appbar .cart-list .goods-pic a {
  line-height: 0;
  background: none;
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  *display: block;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.nc-appbar .cart-list .goods-pic a img {
  max-width: 40px;
  max-height: 40px;
  margin-top: expression(40-this.height/2);
}

.nc-appbar .cart-list dl {
  width: 125px;
  margin-left: 5px;
}

.nc-appbar .cart-list .goods-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.nc-appbar .cart-list a.del {
  font: 600 10px/14px Arial;
  color: #fff;
  background-color: #ccc;
  text-align: center;
  width: 14px;
  height: 14px;
  border-radius: 7px;
  position: absolute;
  z-index: 1;
  top: -5px;
  right: -5px;
}

.nc-appbar .cart-list li:hover a.del {
  background-color: #e74649;
}
</style>



// WEBPACK FOOTER //
// sidebar.vue?20f9eed6